document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sb-builder').forEach(initStackBuilder);
});

function formatMoneyWithShopFormat(cents, format) {
  var value = (cents / 100).toFixed(2);
  var parts = value.split('.');
  var placeholderRegex = /\{\{\s*(amount[a-z_]*)\s*\}\}/;
  var match = format.match(placeholderRegex);
  var formatted = value;

  if (match) {
    var kind = match[1];
    if (kind === 'amount_no_decimals') {
      formatted = parts[0];
    } else if (kind === 'amount_with_comma_separator') {
      formatted = parts[0] + ',' + parts[1];
    } else {
      formatted = value;
    }
    return format.replace(placeholderRegex, formatted);
  }

  return format || ('$' + value);
}

function initStackBuilder(root) {
  var moneyFormat = root.dataset.sbMoneyFormat || '${{amount}}';

  root.querySelectorAll('[data-sb-stack]').forEach(function (card) {
    var checkboxes = card.querySelectorAll('[data-sb-piece-checkbox]');
    var totalEl = card.querySelector('[data-sb-total]');
    var addBtn = card.querySelector('[data-sb-add-stack]');
    var confirmEl = card.querySelector('[data-sb-confirm]');
    var errorEl = card.querySelector('[data-sb-error]');

    function recalcTotal() {
      var total = 0;
      var anyChecked = false;
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          total += parseInt(cb.dataset.price, 10) || 0;
          anyChecked = true;
        }
      });
      if (totalEl) {
        totalEl.textContent = formatMoneyWithShopFormat(total, moneyFormat);
      }
      if (addBtn) {
        addBtn.disabled = !anyChecked;
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', recalcTotal);
    });

    recalcTotal();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        checkboxes.forEach(function (cb) {
          if (cb.checked && cb.dataset.variantId) {
            items.push({ id: cb.dataset.variantId, quantity: 1 });
          }
        });
        if (items.length === 0) return;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'Could not add stack to cart');
              });
            }
            return response.json();
          })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateStackCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            showStackMessage(confirmEl);
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          })
          .catch(function (err) {
            if (errorEl) errorEl.textContent = err.message || 'Something went wrong. Please try again.';
            showStackMessage(errorEl);
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          });
      });
    }
  });
}

function showStackMessage(el) {
  if (!el) return;
  el.removeAttribute('hidden');
  clearTimeout(el._sbTimer);
  el._sbTimer = setTimeout(function () {
    el.setAttribute('hidden', '');
  }, 2500);
}

function updateStackCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
    var span = el.querySelector('span[aria-hidden="true"]');
    if (span) { span.textContent = count; } else { el.textContent = count; }
    el.style.display = count > 0 ? '' : 'none';
  });
}
